/**
 * Deposit Method Model
 */

define(function(require, exports, module) {
    'use strict';
    var _ = require('underscore');
    var utils = require('utils');
    var CashierMethodModel = require('portlets/cashier/cashier.method.model');
    var server = require('server');
    var user = require('user');
    var config = require('config');

    module.exports = CashierMethodModel.extend({

        getRequestData: function(data) {
            return _.extend(
                {
                    ID: 33016,
                    description: 'Deposit',
                    responses: [33015, 33014, 33029],
                    methodCode: this.get('code'),
                    promoCode: data.promoCode,
                    amount: data.amount,
                    uuid: utils.guid(),
                    transactionTags: {
                        transactionTag: [
                            { name: 'cashiertype', value: 'HUB2' }
                        ]
                    }
                },
                this.get3dsCallParams()
            );
        },

        get3dsCallParams: function() {
            return {
                specificParams: {
                    threeDSBrowserAcceptHeader: 'text/html',
                    threeDSBrowserIP: user.get('clientIp'),
                    threeDSBrowserJavaEnabled: navigator.javaEnabled(),
                    threeDSBrowserJavascriptEnabled: true,
                    threeDSBrowserLanguage: navigator.language,
                    threeDSBrowserColorDepth: screen.colorDepth,
                    threeDSBrowserScreenHeight: screen.height,
                    threeDSBrowserScreenWidth: screen.width,
                    threeDSBrowserTimeZone: (new Date()).getTimezoneOffset(),
                    threeDSBrowserUserAgent: navigator.userAgent.substring(0, 2000),
                    threeDSChallengeWindowSize: '05' // fullscreen
                }
            };
        },

        send3DsMethodNotificationRequest: function(params, error, headerParameters) {
            var transactionId = params.transactionId || _.first(headerParameters['X-Transaction-Code']);
            var methodCompletionInd = error ? 'N' : 'Y';

            var threeDSParams = this.get3dsCallParams().specificParams;

            threeDSParams = _.keys(threeDSParams).reduce(function(memo, curr) {
                var key = curr.replace('threeDSB', 'b');

                if (key === 'browserIP') {
                    key = 'browserIp';
                }

                memo[key] = threeDSParams[curr];

                return memo;
            }, {});

            var request = {
                ID: 35720,
                description: '3D Secure v2 Method Notification',
                responses: [35721, 35722],
                threeDSMethodCompletionInd: methodCompletionInd,
                transactionId: transactionId
            };

            return server.send(_.extend(request, threeDSParams));
        },

        deposit: function(data) {
            var request = this.getRequestData(data);
            var account = _.findWhere(this.get('account'), { code: data.accountCode });

            if (this.get('isSubMethod')) {
                request.methodCode = this.get('methodCode');
                request.subMethodsCodes = [this.get('code')];
            } else if (this.get('code') === 'VisaCheckout') {
                request.methodCode = _.findWhere(this.get('account'), { code: data.accountCode }).pmCode;
            }

            request = this.getBackUrls(request, 'deposit', this.get('reDirectType'));

            // Non-generic method
            if (!this.get('isGeneric')) {
                request.accountCode = data.accountCode;
            }

            request.specificParams = _.extend(
                request.specificParams,
                _.omit(
                    data,
                    this.confirmedFields,
                    ['accountCode', 'amount', 'storedAccountId', 'promoCode']
                )
            );

            // additional params
            _.extend(request, _.pick(data, this.confirmedFields));

            if (config.get('cashierClientType')) {
                request.clienttype = config.get('cashierClientType');
            }

            if (!config.get('sendCashierMessagesToGS')) {
                request.xNoPlayermessageToGs = true;
            }

            if (account && account.storeCardConfirmationRequired) {
                request.storeCardConfirmed = true;
            }

            this.handleSpecialPmsDeposit(request, account);

            return server.send(request);
        },

        handleSpecialPmsDeposit: function(request, account) {
            switch (this.get('code')) {
                case 'DotpayBlik':
                    this.handleDotpayBlikDeposit(request);
                    break;
                case 'DotpayCard':
                    this.handleDotpayCardDeposit(request);
                    break;
                case 'DotpayBankTransfer':
                    this.handleDotpayBankTransferDeposit(request);
                    break;
                case 'PayPalViaSC':
                    this.handlePayPalViaSC(request, account);
                    break;
            }
        },

        handlePayPalViaSC: function(request, account) {
            delete request.accountCode;

            var BA_IMS_FIELD_NAME = 'bavalue';
            var UUID_IMS_FIELD_NAME = 'uuid';
            var accountFields = this.get('accountFields');

            if (!accountFields) {
                return;
            }

            var labelToName = accountFields.field.reduce(function(acc, field) {
                var label = field.label.toLocaleLowerCase();

                if (label === BA_IMS_FIELD_NAME || label === UUID_IMS_FIELD_NAME) {
                    acc[label] = field.name;
                }

                return acc;
            }, {});

            if (BA_IMS_FIELD_NAME in labelToName) {
                var isOriginBA = account && account.specificParams[labelToName[BA_IMS_FIELD_NAME]];
                var isBAChecked = request.specificParams[labelToName[BA_IMS_FIELD_NAME]];

                if (isBAChecked) {
                    request.subMethodsCodes = ['ReferenceTransaction'];

                    if (isOriginBA && UUID_IMS_FIELD_NAME in labelToName) {
                        request.specificParams[labelToName[UUID_IMS_FIELD_NAME]] = this.collection.config.uuidForFraud;
                    }
                }
            }
        },

        handleDotpayBankTransferDeposit: function(request) {
            var specParams = request.specificParams;
            request.subMethodsCodes = [specParams.subMethodsCodes];

            delete request.accountCode;
            delete specParams.subMethodsCodes;
        },

        handleDotpayBlikDeposit: function(request) {
            var specParams = request.specificParams;

            if (specParams.altAccount) {
                request.selectedAccount = specParams.altAccount;
                delete specParams.altAccount;
            }
        },

        handleDotpayCardDeposit: function(request) {
            delete request.accountCode;

            if (request.specificParams.field2 === 'add') {
                delete request.specificParams.field2;
            }
        },

        parse: function() {
            var data = CashierMethodModel.prototype.parse.apply(this, arguments);
            var suggested = data.suggested;

            if (!suggested) {
                return data;
            }

            var defaultSuggestion = _.find(suggested.suggestion, function(suggestion) {
                return Boolean(suggestion._default);
            });

            if (defaultSuggestion) {
                data.suggested.default = defaultSuggestion.value;
            }

            return data;
        }
    });
});
